import { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { segmentTrack, segmentPage } from "util/segment";
import { SETTINGS_PATH } from "util/routes";

// Restrict the pages we track on, so as to not overwhelm our Segment data cap
const TRACKED_PATHS = Object.freeze(
  new Set([
    "/signup/starter",
    "/signup/pro",
    "/signup/premium",
    "/signup/upload",
    "/upload",
    "/onboarding",
    SETTINGS_PATH,
  ]),
);

function LocationAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (TRACKED_PATHS.has(pathname)) {
      segmentTrack("Loaded An App Page");
    }
    segmentPage();
  }, [pathname]);
  return null;
}

export default memo(LocationAnalytics);
